/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ({

/***/ "7YTv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _analysis = __webpack_require__("JgKM");

var _analysis2 = _interopRequireDefault(_analysis);

var _documents = __webpack_require__("laaU");

var _documents2 = _interopRequireDefault(_documents);

var _user = __webpack_require__("D3cY");

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Global definition of Vue in bootstrap.js was causing issues, so import of Vue and Vue.use(Vuex) were removed
// Vue.use(Vuex);

// Use a reducer function to only persist certain items
// import Vue from 'vue';
var reducer = function reducer(state) {
  var analysis = state.analysis,
      documents = state.documents,
      user = state.user;

  return {
    analysis: {
      draft: analysis.draft
    }
  };
};

// Create vuex store

// import createPersistedState from 'vuex-persistedstate';
exports.default = new _vuex2.default.Store({
  // plugins: [
  //   createPersistedState({
  //     key: 'myLab',
  //     reducer
  //   })
  // ],
  modules: {
    analysis: _analysis2.default,
    documents: _documents2.default,
    user: _user2.default
  }
});

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("QZk0");


/***/ }),

/***/ "D3cY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getters = __webpack_require__("fvKK");

var _getters2 = _interopRequireDefault(_getters);

var _actions = __webpack_require__("H7LG");

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__("v0fX");

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    user_accounts: [],
    visible_user: {},
    auth_user: {}
};

var userModule = {
    namespaced: true,
    state: state,
    getters: _getters2.default,
    actions: _actions2.default,
    mutations: _mutations2.default
};

exports.default = userModule;

/***/ }),

/***/ "H7LG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var actions = {};

exports.default = actions;

/***/ }),

/***/ "JgKM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getters = __webpack_require__("ZjcF");

var _getters2 = _interopRequireDefault(_getters);

var _actions = __webpack_require__("pRg+");

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__("lXvB");

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    account: false,
    available_crops: [],
    completed_order: false,
    draft: {},
    errors: [],
    import_file: false,
    loaded: {
        draft_order: false,
        sample_type_groups: false,
        sample_type_fields: {},
        sample_type_test_groups: {},
        soil_crop_data: false,
        test_blacklist: false
    },
    loading: {
        draft_order: false,
        sample_type_groups: false,
        sample_type_fields: {},
        sample_type_test_groups: {},
        soil_crop_data: false,
        test_blacklist: false
    },
    processing: false,
    sample_type_fields: {},
    sample_type_groups: [],
    sample_type_test_groups: {},
    screen_layout: 'horizontal',
    soil_crop_data: [],
    test_details: {
        modal: null,
        data: {},
        visible_test_id: 0
    },
    user: false,
    user_can_see_billing: false,
    test_blacklist: []
};

var analysisModule = {
    namespaced: true,
    state: state,
    getters: _getters2.default,
    actions: _actions2.default,
    mutations: _mutations2.default
};

exports.default = analysisModule;

/***/ }),

/***/ "NYxO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return Store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapState", function() { return mapState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapMutations", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapGetters", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapActions", function() { return mapActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNamespacedHelpers", function() { return createNamespacedHelpers; });
/**
 * vuex v2.5.0
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '2.5.0',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["default"] = (index_esm);


/***/ }),

/***/ "QZk0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vuex = __webpack_require__("NYxO");

var _vuex2 = __webpack_require__("7YTv");

var _vuex3 = _interopRequireDefault(_vuex2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!window.myLabMixins) {
    window.myLabMixins = [];
}

window.myLab = new Vue({
    el: '#myLab-app',
    store: _vuex3.default,
    mixins: myLabMixins,
    data: {
        environment: 'production',
        selected_account: {},
        selected_accounts: [],
        phoneModal: null
    },
    computed: _extends({}, (0, _vuex.mapState)('user', ['auth_user', 'visible_user', 'user_accounts']), (0, _vuex.mapGetters)('user', ['hasRole', 'hasIndustry', 'hasStatus', 'hasPhone']), {
        production: function production() {
            return this.environment.toLowerCase() == 'production';
        },
        visible_user_changed: function visible_user_changed() {
            return this.auth_user ? this.auth_user.user_id != this.visible_user.user_id : false;
        }
    }),
    methods: {
        changeVisibleUser: function changeVisibleUser() {
            this.$refs.visibleUserPicker.showSelector();
        }
    },
    mounted: function mounted() {
        var environment = this.$el.getAttribute('environment');
        var selected_account = this.$el.getAttribute('selected_account');
        var selected_accounts = this.$el.getAttribute('selected_accounts');
        var auth_user = this.$el.getAttribute('auth_user');
        var visible_user = this.$el.getAttribute('visible_user');
        var user_accounts = this.$el.getAttribute('user_accounts');

        if (environment != '') {
            this.environment = environment;
        }
        if (selected_account != '') {
            this.selected_account = JSON.parse(selected_account);
        }
        if (selected_accounts != '') {
            this.selected_accounts = JSON.parse(selected_accounts);
        }
        if (auth_user != '') {
            this.$store.commit('user/setAuthUser', JSON.parse(auth_user));
        }
        if (visible_user != '') {
            this.$store.commit('user/setVisibleUser', JSON.parse(visible_user));
        }
        if (user_accounts != '') {
            this.$store.commit('user/setUserAccounts', JSON.parse(user_accounts));
        }

        this.$el.removeAttribute('environment');
        this.$el.removeAttribute('selected_account');
        this.$el.removeAttribute('selected_accounts');
        this.$el.removeAttribute('auth_user');
        this.$el.removeAttribute('visible_user');
        this.$el.removeAttribute('user_accounts');

        this.phoneModal = $(this.$refs.phoneModal);
        $('body').append(this.phoneModal);
    }
});

/***/ }),

/***/ "ZjcF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getters = {
    account_preferences: function account_preferences(state) {
        return state.account.account_preferences || [];
    },
    all_samples: function all_samples(state) {
        return _.has(state, ['draft', 'sample_groups']) ? [].concat.apply([], state.draft.sample_groups.map(function (group) {
            return group.samples;
        })) : [];
    },
    all_invalid_samples: function all_invalid_samples(state, getters) {
        return getters.all_samples.filter(function (sample) {
            return !sample.valid;
        });
    },
    can_change_report_by_setting: function can_change_report_by_setting(state, getters) {
        return !getters.report_by_account_preference || !getters.report_by_account_preference.is_static;
    },
    can_see_billing: function can_see_billing(state) {
        return state.user_can_see_billing;
    },
    invalid_sample_groups: function invalid_sample_groups(state) {
        return _.has(state.draft, 'sample_groups') ? state.draft.sample_groups.filter(function (group) {
            return !group.valid;
        }) : [];
    },
    ready_to_submit: function ready_to_submit(state, getters) {
        return !state.import_file && state.draft.valid && getters.invalid_sample_groups.length == 0 && getters.all_samples.length > 0 && getters.all_invalid_samples.length == 0;
    },
    receipt_url: function receipt_url(state) {
        if (state.completed_order.account_nbr && state.completed_order.processed_orders) {
            var processed_orders = state.completed_order.processed_orders.filter(function (order) {
                return order.file_id;
            });

            switch (processed_orders.length) {
                case 0:
                    break;

                case 1:
                    return '/documents/' + state.completed_order.account_nbr + '/' + processed_orders[0].file_id;
                    break;

                default:
                    var url = '/documents/' + state.completed_order.account_nbr + '?';
                    processed_orders.forEach(function (file) {
                        url += '&fileIds[]=' + file.file_id;
                    });
                    return url;
            }
        }

        return null;
    },
    report_by_account_preference: function report_by_account_preference(state, getters) {
        return getters.account_preferences.find(function (pref) {
            return pref.account_preference_key == "REPORTBY";
        });
    },
    report_by_setting: function report_by_setting(state, getters) {
        return _.has(state.draft, 'details') ? state.draft.details.find(function (detail) {
            return parseInt(detail.field_key) === 1033;
        }) : null;
    },
    report_by_setting_value: function report_by_setting_value(state, getters) {
        return _.has(getters.report_by_setting, 'field_value') ? getters.report_by_setting.field_value : 'order';
    },
    report_comment_field: function report_comment_field(state) {
        return _.has(state.draft, 'details') ? state.draft.details.find(function (detail) {
            return parseInt(detail.field_key) === 1037;
        }) : null;
    },
    report_comment_field_value: function report_comment_field_value(state, getters) {
        return _.has(getters.report_comment_field, 'field_value') ? getters.report_comment_field.field_value : undefined;
    },
    sample_fields_by_sample_type_id: function sample_fields_by_sample_type_id(state, getters) {
        return function (sample_type_id) {
            var fields = getters.sample_type_fields(sample_type_id);
            return _.has(fields, ['sample', 'other']) ? fields.sample.other : [];
        };
    },
    sample_group_by_index: function sample_group_by_index(state) {
        return function (index) {
            return _.has(state.draft, ['sample_groups', index]) ? state.draft.sample_groups[index] : null;
        };
    },
    sample_by_indexes: function sample_by_indexes(state, getters) {
        return function (group_index, sample_index) {
            var sample_group = getters.sample_group_by_index(group_index);
            return _.has(sample_group, ['samples', sample_index]) ? sample_group.samples[sample_index] : null;
        };
    },
    sample_type_by_id: function sample_type_by_id(state) {
        return function (sample_type_id) {
            var sample_type_group = state.sample_type_groups.find(function (group) {
                return group.sampleTypes.filter(function (sample_type) {
                    return sample_type.sampleTypeID == sample_type_id;
                }).length > 0;
            });
            return sample_type_group ? sample_type_group.sampleTypes.find(function (sample_type) {
                return sample_type.sampleTypeID == sample_type_id;
            }) : null;
        };
    },
    sample_type_categories: function sample_type_categories(state) {
        return state.sample_type_groups ? state.sample_type_groups.map(function (group) {
            return {
                title: group.title,
                categories: group.sampleTypes.map(function (sample_type) {
                    return sample_type.category;
                }).filter(function (item, index, array) {
                    return array.indexOf(item) === index;
                })
            };
        }) : [];
    },
    sample_type_fields: function sample_type_fields(state) {
        return function (sample_type_id) {
            return _.has(state.sample_type_fields, sample_type_id) ? state.sample_type_fields[sample_type_id] : null;
        };
    },
    sample_type_test_groups: function sample_type_test_groups(state) {
        return function (sample_type_id) {
            return _.has(state.sample_type_test_groups, sample_type_id) ? state.sample_type_test_groups[sample_type_id] : null;
        };
    },
    validate_field: function validate_field(state) {
        return function (field, field_value) {
            var errors = [];
            var invalid = [];

            if (field.required && !field_value) {
                errors.push(field.caption);
            } else {
                switch (field.format) {
                    case '(yyyy-mm-dd)':
                        if (field_value && !/^\d{4}-\d{2}-\d{2}$/.test(field_value)) {
                            invalid.push(field.caption);
                        }
                        break;

                    case '(hhmm)':
                        if (field_value && !/^([01]\d|2[0-3])([0-5]\d)$/.test(field_value)) {
                            invalid.push(field.caption);
                        }
                        break;

                    case '(depth)':
                        if (field_value) {
                            var depths = field_value.split('-');

                            if (!/^\d+-\d+$/.test(field_value) || parseInt(depths[1]) < parseInt(depths[0])) {
                                invalid.push(field.caption + ' (start-end) ex: 0-6');
                            }
                        }
                        break;

                    case '(email)':
                        if (field_value) {
                            var valid_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
                            var emails = field_value.replace(/\s+/g, '').replace(/\,/g, ';').split(';');
                            emails.forEach(function (email) {
                                if (!invalid.includes(field.caption) && !valid_email.test(String(email))) {
                                    invalid.push(field.caption);
                                }
                            });
                        }

                        break;
                }
            }

            return { errors: errors, invalid: invalid, valid: invalid.length == 0 && errors.length == 0 };
        };
    },
    visible_test_details: function visible_test_details(state) {
        var visible_test_details = state.test_details.data[state.test_details.visible_test_id];
        return visible_test_details ? visible_test_details : { caption: '', price: 0, details: [] };
    },
    test_blacklist: function test_blacklist(state) {
        return state.test_blacklist;
    }
};

exports.default = getters;

/***/ }),

/***/ "fvKK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getters = {
    isAccountInList: function isAccountInList(state) {
        return function (new_account_nbr) {
            return state.user_accounts.map(function (s) {
                if (s.account_nbr) return s.account_nbr;
            }).indexOf(parseInt(new_account_nbr)) !== -1;
        };
    },

    hasAccountRole: function hasAccountRole(state) {
        return function (account_nbr, role_cd) {
            if (state.visible_user.is_sys_admin == 1) {
                return true;
            }

            return state.user_accounts.filter(function (account) {
                return account.account_nbr == account_nbr && _.has(account, ['rolesArray', role_cd]);
            }).length > 0;
        };
    },
    hasRole: function hasRole(state) {
        return function (rolesArray) {
            if (state.visible_user.is_sys_admin == 1) {
                return true;
            }
            for (var i = 0; i < rolesArray.length; i++) {
                if (state.visible_user.approved_roles) {
                    if (state.visible_user.approved_roles.includes(rolesArray[i])) {
                        return true;
                    }
                }
            }
            return false;
        };
    },

    hasStatus: function hasStatus(state) {
        return function (statusArray) {
            if (statusArray.indexOf(state.visible_user.status_cd) > -1) {
                return true;
            }
        };
    },

    hasIndustry: function hasIndustry(state) {
        return function (industryArray) {
            if (state.visible_user.is_sys_admin == 1) {
                return true;
            }
            return state.user_accounts.some(function (user_account) {
                return industryArray.indexOf(user_account.account.default_industry_id) > -1;
            });
        };
    },

    hasPhone: function hasPhone(state) {
        return function () {
            return state.visible_user.phone1 != "";
        };
    }
};

exports.default = getters;

/***/ }),

/***/ "j8Ko":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var actions = {
    sortRows: function sortRows(_ref, sort_info) {
        var commit = _ref.commit,
            state = _ref.state;

        state.rows.sort(function (a, b) {
            a = _.has(a, 'data', sort_info.column) ? a.data[sort_info.column] : null;
            b = _.has(b, 'data', sort_info.column) ? b.data[sort_info.column] : null;
            if (a === null && b === null) return 0;
            if (a === null) return 1;
            if (b === null) return -1;
            switch (sort_info.method ? sort_info.method : 'alph') {
                case 'numeric':
                    return a - b;
                    break;
                case 'date':
                    a = new Date(a);
                    b = new Date(b);
                    break;
                default:
            }
            return a > b ? 1 : a < b ? -1 : 0;
        });

        if (sort_info.descending) {
            state.rows.reverse();
        }

        state.activeSort = {
            column: sort_info.column,
            direction: sort_info.descending ? 'desc' : 'asc'
        };
    },

    updateRows: function updateRows(_ref2, data) {
        var commit = _ref2.commit;

        if (!('rows' in data) && Array.isArray(data)) {
            data.rows = data;
        }
        if (!('filter_data' in data)) {
            data.filter_data = data.rows;
        }
        commit('UPDATE_ROWS', data.rows);
    },

    toggleInProgress: function toggleInProgress(_ref3) {
        var commit = _ref3.commit;

        commit('TOGGLE_IN_PROGRESS');
    },

    selectRow: function selectRow(_ref4, row_index) {
        var commit = _ref4.commit,
            getters = _ref4.getters;

        commit('SELECT_ROW', getters.visibleRows[row_index]);
    },

    deselectRow: function deselectRow(_ref5, row_index) {
        var commit = _ref5.commit,
            getters = _ref5.getters;

        commit('DESELECT_ROW', getters.visibleRows[row_index]);
    },

    removeFilter: function removeFilter(_ref6, info) {
        var commit = _ref6.commit,
            state = _ref6.state;

        commit('REMOVE_FILTER', info);
    },

    removeColumnFilters: function removeColumnFilters(_ref7, column) {
        var commit = _ref7.commit,
            state = _ref7.state;

        if (column && _.has(state.activeFilters, column)) {
            _.clone(state.activeFilters[column]).forEach(function (filter) {
                commit('REMOVE_FILTER', { column: column, filter: filter });
            });
        }
    },

    addFilter: function addFilter(_ref8, info) {
        var commit = _ref8.commit,
            state = _ref8.state;

        commit('ADD_FILTER', info);
    },

    changeStartDate: function changeStartDate(_ref9, date) {
        var commit = _ref9.commit;

        commit('CHANGE_START_DATE', date);
    },

    changeEndDate: function changeEndDate(_ref10, date) {
        var commit = _ref10.commit;

        commit('CHANGE_END_DATE', date);
    },

    searchUpdated: function searchUpdated(_ref11) {
        var commit = _ref11.commit;
        var updated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        commit('NEED_TO_SEARCH', updated);
    },

    checkSelectAllButton: function checkSelectAllButton(_ref12) {
        var commit = _ref12.commit;
        var checked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        commit('SELECT_ALL_CHECKED', checked);
    },

    toggleBalanceColumn: function toggleBalanceColumn(_ref13) {
        var commit = _ref13.commit;
        var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        commit('SHOW_BALANCE_COLUMN', visible);
    },

    updateClientSampleTypes: function updateClientSampleTypes(_ref14) {
        var commit = _ref14.commit;
        var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        commit('UPDATE_CLIENT_SAMPLE_TYPES', items);
    },

    updateSelectedSampleTypes: function updateSelectedSampleTypes(_ref15) {
        var commit = _ref15.commit;
        var selection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        commit('UPDATE_SELECTED_SAMPLE_TYPES', selection);
    },

    updateDocTypes: function updateDocTypes(_ref16) {
        var commit = _ref16.commit;
        var types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        commit('UPDATE_DOCUMENT_TYPES', types);
    },

    updateSelectedDocTypeCodes: function updateSelectedDocTypeCodes(_ref17) {
        var commit = _ref17.commit;
        var codes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        commit('UPDATE_SELECTED_DOC_TYPE_CODES', codes);
    },

    updateUserAccountRoles: function updateUserAccountRoles(_ref18) {
        var commit = _ref18.commit;
        var userAccountRoles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        commit('UPDATE_USER_ACCOUNT_ROLES', userAccountRoles);
    },

    updateUserIsSysAdmin: function updateUserIsSysAdmin(_ref19) {
        var commit = _ref19.commit,
            state = _ref19.state;
        var is_sys_admin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        commit('UPDATE_USER_IS_SYS_ADMIN', is_sys_admin);
    },

    setItemValue: function setItemValue(_ref20) {
        var commit = _ref20.commit;
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        commit('SET_ITEM_VALUE', params);
    },

    getReportFormats: function getReportFormats(_ref21, account_nbr) {
        var commit = _ref21.commit;

        commit('GET_REPORT_FORMATS', account_nbr);
    },
    emailReports: function emailReports(_ref22, params) {
        var commit = _ref22.commit;

        commit('EMAIL_REPORTS', params);
    }
};

exports.default = actions;

/***/ }),

/***/ "kOoB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var mutations = {
    UPDATE_ROWS: function UPDATE_ROWS(state, rows) {
        state.selectAllChecked = false;
        state.rows = rows;
        state.statelessRowData = JSON.parse(JSON.stringify(rows));
        state.activeFilters = {};
    },
    REMOVE_FILTER: function REMOVE_FILTER(state, info) {
        if (!('column' in info) || !('filter' in info)) {
            return false;
        }
        var filter = info.filter;

        state.rows.filter(function (row) {
            return row.selected || row.expanded;
        }).forEach(function (row) {
            Vue.set(row, 'selected', false);
            Vue.set(row, 'expanded', false);
        });

        state.selectAllChecked = false;

        state.rows.filter(function (row) {
            return !row.hidden;
        }).forEach(function (row, index) {
            if (_.has(row, 'data', info.column) && row.data[info.column] && row.data[info.column] == filter) {
                Vue.set(row, 'hidden', true);
            }
        });

        state.activeFilters[info.column].splice(state.activeFilters[info.column].indexOf(info.filter), 1);

        if (state.activeFilters[info.column].length === 0) {
            delete state.activeFilters[info.column];
        }

        if (Object.keys(state.activeFilters).length === 0) {
            state.rows.filter(function (row) {
                return row.hidden;
            }).forEach(function (row, index) {
                Vue.set(row, 'hidden', false);
            });
        } else {
            var rows = state.rows.filter(function (row) {
                return row.hidden;
            });

            var _loop = function _loop(column) {
                rows = rows.filter(function (row) {
                    return _.has(row, 'data', column) && row.data[column] && state.activeFilters[column].includes(row.data[column]);
                });
            };

            for (var column in state.activeFilters) {
                _loop(column);
            }
            rows.forEach(function (row, index) {
                Vue.set(row, 'hidden', false);
            });
        }
    },
    ADD_FILTER: function ADD_FILTER(state, info) {
        if (!('column' in info) || !('filter' in info)) {
            return false;
        }

        var filter = info.filter;

        state.rows.filter(function (row) {
            return row.selected || row.expanded;
        }).forEach(function (row) {
            Vue.set(row, 'selected', false);
            Vue.set(row, 'expanded', false);
        });

        state.selectAllChecked = false;

        if (!_.has(state.activeFilters, info.column)) {
            Vue.set(state.activeFilters, info.column, []);
        }

        state.activeFilters[info.column].push(filter);

        // First filter
        if (Object.keys(state.activeFilters).length === 1 && state.activeFilters[info.column].length === 1) {
            state.rows.forEach(function (row, index) {
                if (_.has(row, 'data', info.column) && row.data[info.column] && row.data[info.column] == filter) {
                    Vue.set(row, 'hidden', false);
                } else {
                    Vue.set(row, 'hidden', true);
                }
            });
        }
        // Only filtering on 1 column
        else if (Object.keys(state.activeFilters).length === 1) {
                state.rows.filter(function (row) {
                    return row.hidden;
                }).forEach(function (row, index) {
                    if (_.has(row, 'data', info.column) && row.data[info.column] && row.data[info.column] == filter) {
                        Vue.set(row, 'hidden', false);
                    }
                });
            }
            // Filtering on multiple columns
            else {
                    state.rows.filter(function (row) {
                        return !row.hidden;
                    }).forEach(function (row, index) {
                        if (!_.has(row, 'data', info.column) || !row.data[info.column] || row.data[info.column] != filter) {
                            Vue.set(row, 'hidden', true);
                        }
                    });

                    var rows = state.rows.filter(function (row) {
                        return row.hidden;
                    });

                    var _loop2 = function _loop2(column) {
                        rows = rows.filter(function (row) {
                            return _.has(row, 'data', column) && row.data[column] && state.activeFilters[column].includes(row.data[column]);
                        });
                    };

                    for (var column in state.activeFilters) {
                        _loop2(column);
                    }
                    rows.forEach(function (row, index) {
                        Vue.set(row, 'hidden', false);
                    });
                }
    },
    TOGGLE_IN_PROGRESS: function TOGGLE_IN_PROGRESS(state) {
        state.showInProgress = !state.showInProgress;
    },
    SELECT_ROW: function SELECT_ROW(state, row) {
        Vue.set(row, 'selected', true);
    },
    DESELECT_ROW: function DESELECT_ROW(state, row) {
        Vue.set(row, 'selected', false);
    },
    CHANGE_START_DATE: function CHANGE_START_DATE(state, date) {
        if (date != state.startDate) {
            state.startDate = date;
            state.needToSearch = true;
        }
    },
    CHANGE_END_DATE: function CHANGE_END_DATE(state, date) {
        if (date != state.endDate) {
            state.endDate = date;
            state.needToSearch = true;
        }
    },
    NEED_TO_SEARCH: function NEED_TO_SEARCH(state, needToSearch) {
        state.needToSearch = needToSearch;
    },
    SELECT_ALL_CHECKED: function SELECT_ALL_CHECKED(state, checked) {
        state.selectAllChecked = checked;
    },
    SHOW_BALANCE_COLUMN: function SHOW_BALANCE_COLUMN(state, visible) {
        state.showBalanceColumn = visible;
    },
    UPDATE_CLIENT_SAMPLE_TYPES: function UPDATE_CLIENT_SAMPLE_TYPES(state, items) {
        state.clientSampleTypes = items;
    },
    UPDATE_SELECTED_SAMPLE_TYPES: function UPDATE_SELECTED_SAMPLE_TYPES(state, selection) {
        state.selectedSampleTypes = selection;
    },
    UPDATE_DOCUMENT_TYPES: function UPDATE_DOCUMENT_TYPES(state, types) {
        state.docTypes = types;
    },
    UPDATE_SELECTED_DOC_TYPE_CODES: function UPDATE_SELECTED_DOC_TYPE_CODES(state, codes) {
        for (var i = 0; i < state.docTypes.length; i++) {
            Vue.set(state.docTypes[i], 'selected', codes.indexOf(state.docTypes[i].document_type_cd) != -1);
        }
    },
    UPDATE_USER_ACCOUNT_ROLES: function UPDATE_USER_ACCOUNT_ROLES(state, userAccountRoles) {
        state.userAccountRoles = {};
        userAccountRoles.forEach(function (item) {
            if (item.roles) {
                var roles = Array.isArray(item.roles) ? item.roles : item.roles.split(',');
                if (item.account_nbr) Vue.set(state.userAccountRoles, item.account_nbr, roles);
            }
        });
    },
    UPDATE_USER_IS_SYS_ADMIN: function UPDATE_USER_IS_SYS_ADMIN(state, is_sys_admin) {
        state.userIsSysAdmin = is_sys_admin;
    },
    SET_ITEM_VALUE: function SET_ITEM_VALUE(state, params) {
        if (_.has(params, 'item') && _.has(params, 'key') && _.has(params, 'value')) {
            Vue.set(params.item, params.key, params.value);
        }
    },
    GET_REPORT_FORMATS: function GET_REPORT_FORMATS(state, account_nbr) {
        axios.get('/documents/reports/formats/' + account_nbr).then(function (response) {
            if (response.data) {
                Vue.set(state.reportFormats, account_nbr, response.data);
            }
        });
    },
    EMAIL_REPORTS: function EMAIL_REPORTS(state, params) {
        axios.put('/documents/reports/email', params).then(function (response) {
            toastr.success('Please allow up to 15 minutes for them to arrive.', 'Your reports have been scheduled for delivery!');
        }).catch(function (error) {
            toastr.error('If this problem continues, please contact Midwest Laboratories.', 'Error!');
        });
    }
};

exports.default = mutations;

/***/ }),

/***/ "lXvB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function insertSamplesIntoGroup(sampleGroup, new_samples) {
    new_samples.forEach(function (sample) {
        if (sample.parent_analysis_sample_id) {
            var parent_sample_index = sampleGroup.samples.findIndex(function (s) {
                return s.analysis_sample_id == sample.parent_analysis_sample_id;
            });

            if (parent_sample_index !== -1) {
                var next_main_sample_index = sampleGroup.samples.filter(function (s, i) {
                    return i > parent_sample_index;
                }).findIndex(function (s) {
                    return !s.parent_analysis_sample_id;
                });

                if (next_main_sample_index === -1) {
                    sampleGroup.samples.push(sample);
                } else {
                    var sample_index = parent_sample_index + next_main_sample_index + 1;
                    sampleGroup.samples.splice(sample_index, 0, sample);
                }
            } else {
                sampleGroup.samples.push(sample);
            }
        } else {
            sampleGroup.samples.push(sample);
        }
    });
}

var mutations = {
    ADD_IMPORTS_TO_SAMPLE_GROUP: function ADD_IMPORTS_TO_SAMPLE_GROUP(state, params) {
        if (!params.analysis_sample_group_id || !params.samples || !params.keys || params.samples.length == 0 || params.keys.length == 0) return;

        var sample_group = state.draft.sample_groups.find(function (group) {
            return group.analysis_sample_group_id === params.analysis_sample_group_id;
        });

        if (sample_group) {
            if (!_.has(sample_group, 'importing')) {
                Vue.set(sample_group, 'importing', {
                    keys: params.keys,
                    samples: params.samples,
                    order: params.keys
                });
            } else if (_.has(sample_group, ['importing', 'keys']) && !_.isEqual(sample_group.importing.keys.sort(), params.keys.sort())) {
                return;
            } else {
                var _sample_group$importi;

                (_sample_group$importi = sample_group.importing.samples).push.apply(_sample_group$importi, _toConsumableArray(params.samples));
            }

            if (typeof params.onSuccess === 'function') {
                params.onSuccess();
            }
        }
    },
    ADD_SAMPLE_GROUP: function ADD_SAMPLE_GROUP(state) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!state.draft.analysis_order_id) return;

        axios.post('/analysis/' + state.draft.analysis_order_id + '/groups').then(function (response) {
            if (response.data) {
                state.draft.sample_groups.push(response.data);

                if (typeof params.onSuccess === 'function') {
                    params.onSuccess(response.data);
                }
            }
        });
    },
    ADD_SAMPLES_TO_GROUP: function ADD_SAMPLES_TO_GROUP(state, _ref) {
        var group = _ref.group,
            new_samples = _ref.new_samples;

        if (!group || !Array.isArray(group.samples)) return;

        insertSamplesIntoGroup(group, new_samples);
    },
    ADD_TEMP_SAMPLES_TO_GROUP: function ADD_TEMP_SAMPLES_TO_GROUP(state, _ref2) {
        var _sampleGroup$samples;

        var group = _ref2.group,
            tempSamples = _ref2.tempSamples;

        var sampleGroup = state.draft.sample_groups.find(function (g) {
            return g.analysis_sample_group_id === group.analysis_sample_group_id;
        });

        if (!sampleGroup) return;

        if (!Array.isArray(sampleGroup.samples)) {
            Vue.set(sampleGroup, 'samples', []);
        }

        (_sampleGroup$samples = sampleGroup.samples).push.apply(_sampleGroup$samples, _toConsumableArray(tempSamples));
    },
    REPLACE_TEMP_SAMPLES_WITH_REAL: function REPLACE_TEMP_SAMPLES_WITH_REAL(state, _ref3) {
        var group = _ref3.group,
            tempSamples = _ref3.tempSamples,
            new_samples = _ref3.new_samples;

        var sampleGroup = state.draft.sample_groups.find(function (g) {
            return g.analysis_sample_group_id === group.analysis_sample_group_id;
        });

        if (!sampleGroup || !Array.isArray(sampleGroup.samples)) return;

        var overridesByIndex = [];

        // Soil default: depth = "0-"
        if (group.sample_type_id === 2223) {
            tempSamples.forEach(function (temp, idx) {
                var depthDetail = (temp.details || []).find(function (d) {
                    return d.field_key === 'depth';
                });

                if (depthDetail && depthDetail.field_value && depthDetail.field_value !== '0-') {
                    overridesByIndex[idx] = {
                        depth: depthDetail.field_value
                    };
                }
            });
        }

        var tempIds = new Set(tempSamples.map(function (s) {
            return s.analysis_sample_id;
        }));

        sampleGroup.samples = sampleGroup.samples.filter(function (sample) {
            return !tempIds.has(sample.analysis_sample_id);
        });

        var samplesToInsert = new_samples.map(function (sample, idx) {
            var clone = JSON.parse(JSON.stringify(sample));
            var overrides = overridesByIndex[idx];

            if (overrides && overrides.depth != null) {
                var depthDetail = (clone.details || []).find(function (d) {
                    return d.field_key === 'depth';
                });
                if (depthDetail) {
                    depthDetail.field_value = overrides.depth;
                } else {
                    clone.details = clone.details || [];
                    clone.details.push({
                        field_key: 'depth',
                        field_value: overrides.depth
                    });
                }
            }

            return clone;
        });

        insertSamplesIntoGroup(sampleGroup, samplesToInsert);
    },
    REMOVE_TEMP_SAMPLES_FROM_GROUP: function REMOVE_TEMP_SAMPLES_FROM_GROUP(state, _ref4) {
        var group = _ref4.group,
            tempSamples = _ref4.tempSamples;

        var sampleGroup = state.draft.sample_groups.find(function (g) {
            return g.analysis_sample_group_id === group.analysis_sample_group_id;
        });

        if (!sampleGroup || !Array.isArray(sampleGroup.samples)) return;

        var tempIds = new Set(tempSamples.map(function (s) {
            return s.analysis_sample_id;
        }));

        sampleGroup.samples = sampleGroup.samples.filter(function (sample) {
            return !tempIds.has(sample.analysis_sample_id);
        });
    },
    CHANGE_SCREEN_LAYOUT: function CHANGE_SCREEN_LAYOUT(state, layout) {
        state.screen_layout = layout;
    },
    DELETE_ITEM_KEY: function DELETE_ITEM_KEY(state, params) {
        if (_.has(params, 'item') && _.has(params, 'key')) {
            Vue.delete(params.item, params.key);
        }
    },
    DISMISS_ERROR: function DISMISS_ERROR(state, index) {
        state.errors.splice(index, 1);
    },
    GET_SOIL_CROP_DATA: function GET_SOIL_CROP_DATA(state) {
        if (state.soil_crop_data.length > 0 || state.loading.soil_crop_data) return;

        state.loaded.soil_crop_data = false;
        state.loading.soil_crop_data = true;

        axios.get('/soils/recommendations/crops').then(function (response) {
            if (response.data) {
                state.soil_crop_data = response.data.map(function (crop) {
                    crop.average_yield = parseInt(crop.average_yield);
                    return crop;
                });

                state.loaded.soil_crop_data = true;
            }

            state.loading.soil_crop_data = false;
        });
    },
    INITIALIZE_TEST_DETAILS_MODAL: function INITIALIZE_TEST_DETAILS_MODAL(state, el) {
        state.test_details.modal = $(el);
    },
    UPDATE_DRAFT_ORDER: function UPDATE_DRAFT_ORDER(state, draft) {
        // TODO: why is this so slow to load?
        state.draft = draft;
        state.loading.draft_order = _.isEmpty(draft);
        state.loaded.draft_order = !state.loading.draft_order;
    },
    UPDATE_LOADING: function UPDATE_LOADING(state, loading) {
        for (var item in loading) {
            Vue.set(state.loading, item, loading[item]);
        }
    },
    LOAD_SAMPLE_TYPE_FIELDS: function LOAD_SAMPLE_TYPE_FIELDS(state, sample_type_id) {
        if (!_.has(state.sample_type_fields, sample_type_id) && !state.loading.sample_type_fields[sample_type_id]) {
            Vue.set(state.loaded.sample_type_fields, sample_type_id, false);
            Vue.set(state.loading.sample_type_fields, sample_type_id, true);

            axios.get('/analysis/custom-fields', {
                params: {
                    account_number: state.account.account_nbr,
                    sample_type_id: sample_type_id
                }
            }).then(function (response) {
                if (response.data) {
                    var fields = response.data;

                    Vue.set(state.sample_type_fields, sample_type_id, {
                        order: fields.order_fields,
                        group: fields.group_fields,
                        sample: {
                            id: fields.sample_id,
                            other: fields.sample_fields
                        },
                        child_sample: fields.child_sample_fields,
                        links: fields.links
                    });

                    Vue.set(state.loading.sample_type_fields, sample_type_id, false);
                    Vue.set(state.loaded.sample_type_fields, sample_type_id, true);
                }
            });
        }
    },
    LOAD_SAMPLE_TYPE_TESTS: function LOAD_SAMPLE_TYPE_TESTS(state, sample_type_id) {
        if (!_.has(state.sample_type_test_groups, sample_type_id)) {
            Vue.set(state.loaded.sample_type_test_groups, sample_type_id, false);
            Vue.set(state.loading.sample_type_test_groups, sample_type_id, true);
            Vue.set(state.sample_type_test_groups, sample_type_id, []);

            axios.get('/analysis/tests', {
                params: {
                    account_number: state.account.account_nbr,
                    sample_type_id: sample_type_id
                }
            }).then(function (response) {
                if (response.data) {
                    Vue.set(state.sample_type_test_groups, sample_type_id, response.data);
                    Vue.set(state.loading.sample_type_test_groups, sample_type_id, false);
                    Vue.set(state.loaded.sample_type_test_groups, sample_type_id, true);
                }
            });
        }
    },
    LOAD_SAMPLE_TYPE_GROUPS: function LOAD_SAMPLE_TYPE_GROUPS(state) {
        if (_.has(state.account, 'account_nbr') && !state.loading.sample_type_groups) {
            state.sample_type_groups = [];
            state.loading.sample_type_groups = true;
            state.loaded.sample_type_groups = false;

            axios.get('/analysis/sample-types/' + state.account.account_nbr).then(function (response) {
                if (response.data) {
                    state.sample_type_groups = response.data;
                    state.loading.sample_type_groups = false;
                    state.loaded.sample_type_groups = true;
                }
            });
        }
    },
    REMOVE_ITEM_FROM_ARRAY: function REMOVE_ITEM_FROM_ARRAY(state, params) {
        if (_.has(params, 'array') && _.has(params, 'item')) {
            var item_index = params.array.findIndex(function (item) {
                return item === params.item;
            });

            if (item_index !== -1) {
                params.array.splice(item_index, 1);
            }
        }
    },
    REMOVE_SAMPLE_GROUP: function REMOVE_SAMPLE_GROUP(state, group) {
        if (!group || !group.analysis_sample_group_id) return;

        Vue.set(state.loading, 'updating_samples', true);

        var removeFromDraft = function removeFromDraft() {
            var deleted_sample_group = state.draft.sample_groups.map(function (draft_group, index) {
                draft_group.draft_group_index = index;
                return draft_group;
            }).find(function (draft_group) {
                return draft_group.analysis_sample_group_id == group.analysis_sample_group_id;
            });

            if (_.has(deleted_sample_group, 'draft_group_index')) {
                state.draft.sample_groups.splice(deleted_sample_group.draft_group_index, 1);
            }

            Vue.set(state.loading, 'updating_samples', false);
        };

        axios.delete('/analysis/' + state.draft.analysis_order_id + '/groups/' + group.analysis_sample_group_id).then(removeFromDraft).catch(function () {
            Vue.set(state.loading, 'updating_samples', false);
        });
    },
    REMOVE_SAMPLE_FROM_GROUP: function REMOVE_SAMPLE_FROM_GROUP(state, _ref5) {
        var group = _ref5.group,
            sample = _ref5.sample;

        if (!sample || !sample.analysis_sample_group_id || !sample.analysis_sample_id) return;

        Vue.set(state.loading, 'updating_samples', true);

        axios.delete('/analysis/' + state.draft.analysis_order_id + '/groups/' + sample.analysis_sample_group_id + '/samples/' + sample.analysis_sample_id).then(function (response) {
            var sample_indexes = [];

            group.samples.map(function (group_sample, index) {
                group_sample.sample_index = index;
                return group_sample;
            }).forEach(function (group_sample) {
                if (group_sample.analysis_sample_id == sample.analysis_sample_id || group_sample.parent_analysis_sample_id == sample.analysis_sample_id) {
                    sample_indexes.push(group_sample.sample_index);
                }
            });

            sample_indexes.reverse().forEach(function (sample_index) {
                group.samples.splice(sample_index, 1);
            });

            Vue.set(state.loading, 'updating_samples', false);
        });
    },
    REMOVE_SAMPLES_FROM_GROUP: function REMOVE_SAMPLES_FROM_GROUP(state, _ref6) {
        var group = _ref6.group,
            analysis_sample_ids = _ref6.analysis_sample_ids;

        if (!Array.isArray(analysis_sample_ids) || analysis_sample_ids.length === 0) return;

        var sample_indexes = [];

        group.samples.map(function (group_sample, index) {
            group_sample.sample_index = index;
            return group_sample;
        }).forEach(function (group_sample) {
            if (analysis_sample_ids.includes(group_sample.analysis_sample_id) || analysis_sample_ids.includes(group_sample.parent_analysis_sample_id)) {
                sample_indexes.push(group_sample.sample_index);
            }
        });

        sample_indexes.reverse().forEach(function (sample_index) {
            group.samples.splice(sample_index, 1);
        });
    },
    REMOVE_SOIL_REC: function REMOVE_SOIL_REC(state, _ref7) {
        var sample = _ref7.sample,
            rec_index = _ref7.rec_index;

        sample.soilrecs.splice(rec_index, 1);
    },
    SAVE_ORDER_DETAILS: function SAVE_ORDER_DETAILS(state) {
        if (!state.draft || !state.draft.analysis_order_id || state.draft.saving) return;

        Vue.set(state.draft, 'saving', true);

        axios.put('/analysis/' + state.draft.analysis_order_id + '/details', {
            details: state.draft.details
        }).then(function (response) {
            if (response.data && response.data.details) {
                Vue.set(state.draft, 'details', response.data.details);
            }

            Vue.nextTick(function () {
                Vue.set(state.draft, 'saving', false);
            });
        });
    },
    SHOW_TEST_DETAILS: function SHOW_TEST_DETAILS(state, _ref8) {
        var sample_type = _ref8.sample_type,
            test = _ref8.test;

        if (!sample_type || !test) return;

        var sample_type_id = sample_type.sampleTypeID;
        var test_id = test.ID;

        state.test_details.modal.modal('show');
        state.test_details.visible_test_id = test_id;

        if (!state.test_details.data[test_id]) {
            axios.get('/analysis/tests/' + sample_type_id + '/' + test_id).then(function (response) {
                if (response.data) {
                    Vue.set(state.test_details.data, test_id, {
                        caption: test.caption,
                        price: test.price,
                        details: response.data
                    });
                }
            });
        }
    },
    SET_ACCOUNT: function SET_ACCOUNT(state, account) {
        state.account = account;
        Vue.set(state.loaded, 'sample_type_fields', {});
        Vue.set(state, 'sample_type_fields', {});
        Vue.set(state.loaded, 'sample_type_test_groups', {});
        Vue.set(state, 'sample_type_test_groups', {});
    },
    SET_ITEM_VALUE: function SET_ITEM_VALUE(state, params) {
        if (_.has(params, 'item') && _.has(params, 'key') && _.has(params, 'value')) {
            Vue.set(params.item, params.key, params.value);
        }
    },
    SET_USER: function SET_USER(state, user) {
        state.user = user;
    },
    SUBMIT_DRAFT_ORDER: function SUBMIT_DRAFT_ORDER(state) {
        if (!state.draft.analysis_order_id) return;

        Vue.set(state.loading, 'draft_order', true);

        axios.post('/analysis/' + state.draft.analysis_order_id + '/submit').then(function (response) {
            if (response.data) {
                Vue.set(state, 'completed_order', response.data);
            }

            Vue.set(state.loading, 'draft_order', false);
        }).catch(function (error) {
            var errors = _.has(error, ['response', 'data', 'errors']) ? error.response.data.errors : {};
            errors = Object.keys(errors).map(function (item) {
                return errors[item];
            }).flatten();
            var error_message = errors.length > 0 ? errors[0] : '';
            console.log({ error_message: error_message, errors: errors });
            Vue.set(state.loading, 'draft_order', false);
            toastr.error('There was an error submitting your order.<br><br>' + error_message, 'Error', {
                positionClass: 'toast-bottom-right',
                closeButton: true,
                tapToDismiss: false,
                timeOut: 0,
                extendedTimeOut: 0
            });
        });
    },
    UPDATE_AVAILABLE_CROPS: function UPDATE_AVAILABLE_CROPS(state) {
        var available_crops = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.available_crops = available_crops;
    },
    UPDATE_IMPORT_FILE: function UPDATE_IMPORT_FILE(state) {
        var import_file = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        state.import_file = import_file;
    },
    UPDATE_USER_BILLING: function UPDATE_USER_BILLING(state) {
        var can_see = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        state.user_can_see_billing = can_see;
    },
    UPDATING_SAMPLES: function UPDATING_SAMPLES(state) {
        var updating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        Vue.set(state.loading, 'updating_samples', updating);
    },
    UPDATE_UNAVAILABLE_TESTS: function UPDATE_UNAVAILABLE_TESTS(state, _ref9) {
        var group = _ref9.group,
            unavailable_tests = _ref9.unavailable_tests;

        Vue.set(group, 'unavailable_tests', unavailable_tests);
    },
    LOAD_TEST_BLACKLIST: function LOAD_TEST_BLACKLIST(state) {
        if (!state.loading.test_blacklist) {
            state.test_blacklist = [];
            state.loading.test_blacklist = true;
            state.loaded.test_blacklist = false;

            axios.get('/analysis/testBlacklist/' + state.account.account_nbr).then(function (response) {
                if (response.data) {
                    state.test_blacklist = response.data;
                    state.loading.test_blacklist = false;
                    state.loaded.test_blacklist = true;
                }
            });
        }
    }
};

exports.default = mutations;

/***/ }),

/***/ "laaU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getters = __webpack_require__("oMP5");

var _getters2 = _interopRequireDefault(_getters);

var _actions = __webpack_require__("j8Ko");

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__("kOoB");

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var momentFormat = 'YYYY-MM-DD';
var today = moment();

var state = {
    rows: [],
    statelessRowData: [],
    docTypes: [],
    endDate: today.format(momentFormat),
    startDate: today.subtract(1, 'months').format(momentFormat),
    needToSearch: true,
    selectAllChecked: false,
    showBalanceColumn: false,
    clientSampleTypes: [],
    selectedSampleTypes: [],
    showInProgress: true,
    userAccountRoles: {},
    userIsSysAdmin: false,
    activeFilters: {},
    activeSort: {},
    reportFormats: {}
};

var documentsModule = {
    namespaced: true,
    state: state,
    getters: _getters2.default,
    actions: _actions2.default,
    mutations: _mutations2.default
};

exports.default = documentsModule;

/***/ }),

/***/ "oMP5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getters = {
    visibleRows: function visibleRows(state) {
        return state.rows.filter(function (row) {
            return !row.hidden && (state.showInProgress || row.details.complete);
        });
    },

    selectableRows: function selectableRows(state) {
        return state.rows.filter(function (row) {
            return row.selectable;
        });
    },

    selectedRows: function selectedRows(state) {
        return state.rows.filter(function (row) {
            return row.selected;
        });
    },

    selectedForGridView: function selectedForGridView(state) {
        return state.rows.filter(function (row) {
            return row.selected && (!row.account.is_credit_card || !Number(row.details.balanceDue));
        });
    },

    hiddenRows: function hiddenRows(state) {
        return state.rows.filter(function (row) {
            return row.hidden;
        });
    },

    specificPageRows: function specificPageRows(state, getters) {
        return function (info) {
            if (!('page' in info)) {
                info.page = 1;
            }
            if (!('itemsPerPage' in info)) {
                info.itemsPerPage = 100;
            }
            var start = (info.page - 1) * info.itemsPerPage;
            return getters.visibleRows.slice(start, start + info.itemsPerPage);
        };
    },

    clientSampleTypeNames: function clientSampleTypeNames(state) {
        var categories = [];
        state.clientSampleTypes.forEach(function (item) {
            var i = categories.map(function (c) {
                return c.category;
            }).indexOf(item.category);
            if (i == -1) {
                i = categories.length;
                categories.push({ category: item.category, sampleTypes: [] });
            }
            if (categories[i].sampleTypes.map(function (st) {
                return st.toLowerCase();
            }).indexOf(item.sampleType.toLowerCase()) == -1) {
                var formula = item.formula ? item.formula + ' -- ' : '';
                categories[i].sampleTypes.push(formula + item.sampleType);
            }
        });
        return categories;
    },

    selectedDocTypeCodes: function selectedDocTypeCodes(state) {
        var selected = state.docTypes.filter(function (docType) {
            return docType.selected;
        });
        var docTypes = selected.length || state.docTypes.length > 1 ? selected : state.docTypes;
        return docTypes.map(function (docType) {
            return docType.document_type_cd;
        });
    },

    availableReportTypes: function availableReportTypes(state) {
        return state.rows.filter(function (row) {
            return row.type.code == 'report';
        }).map(function (row) {
            return row.details.reportType.toLowerCase();
        }).filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
    },

    totalBalanceDue: function totalBalanceDue(state) {
        var balance = 0;
        state.rows.forEach(function (row) {
            if (row.account.is_credit_card) {
                if (row.details.balance) balance += parseInt(row.details.balance);else if (row.details.balanceDue) balance += parseInt(row.details.balanceDue);
            }
        });
        return balance;
    },

    availableReportFormats: function availableReportFormats(state) {
        return function (system, account_nbr) {
            if (system && account_nbr && _.has(state.reportFormats, [account_nbr, system])) {
                return state.reportFormats[account_nbr][system];
            }

            return [];
        };
    }
};

exports.default = getters;

/***/ }),

/***/ "pRg+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var tempSampleIdCounter = 0;
function makeTempSampleId() {
    return 'temp-' + Date.now() + '-' + tempSampleIdCounter++;
}

function buildTempSamples(state, group) {
    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var template = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var baseTemplate = template || {};
    var samples = [];

    var fieldsForType = state.sample_type_fields[group.sample_type_id] || {};
    var parentFields = fieldsForType.sample && fieldsForType.sample.other || [];
    var childFields = fieldsForType.child_sample || [];

    var _loop = function _loop(i) {
        var isChild = !!(baseTemplate.parent_analysis_sample_id || template && template.parent_analysis_sample_id);
        var fieldsForSample = isChild ? childFields : parentFields;

        var details = Array.isArray(baseTemplate.details) ? JSON.parse(JSON.stringify(baseTemplate.details)) : [];

        var existingKeys = new Set(details.map(function (d) {
            return d.field_key.toString();
        }));

        fieldsForSample.forEach(function (field) {
            if (!existingKeys.has(field.fieldNumber.toString())) {
                details.push({
                    field_key: field.fieldNumber,
                    field_value: null,
                    missing: true
                });
            }
        });

        if (!details.some(function (d) {
            return d.field_key === 'tests';
        })) {
            details.push({
                field_key: 'tests',
                field_value: '',
                missing: true
            });
        }

        // Soil default: depth = "0-"
        if (group.sample_type_id == 2223) {
            var depthDetail = details.find(function (d) {
                return d.field_key === 'depth';
            });
            if (!depthDetail) {
                depthDetail = {
                    field_key: 'depth',
                    field_value: '0-',
                    missing: false
                };
                details.push(depthDetail);
            } else if (!depthDetail.field_value) {
                depthDetail.field_value = '0-';
                depthDetail.missing = false;
            }
        }

        samples.push({
            analysis_sample_id: makeTempSampleId(),
            analysis_sample_group_id: group.analysis_sample_group_id,
            parent_analysis_sample_id: baseTemplate.parent_analysis_sample_id || null,
            customer_sample_id: baseTemplate.customer_sample_id || '',
            soilrecs: baseTemplate.soilrecs ? JSON.parse(JSON.stringify(baseTemplate.soilrecs)) : [],
            details: details,
            selected: false,
            saving: true,
            valid: false
        });
    };

    for (var i = 0; i < count; i++) {
        _loop(i);
    }

    return samples;
}

var actions = {
    addImportsToSampleGroup: function addImportsToSampleGroup(_ref, params) {
        var commit = _ref.commit;

        commit('ADD_IMPORTS_TO_SAMPLE_GROUP', params);
    },
    addSampleGroup: function addSampleGroup(_ref2, params) {
        var commit = _ref2.commit;

        commit('ADD_SAMPLE_GROUP', params);
    },
    addSamplesToGroup: function addSamplesToGroup(_ref3, _ref4) {
        var _this = this;

        var state = _ref3.state,
            commit = _ref3.commit;
        var group = _ref4.group,
            count = _ref4.count,
            template = _ref4.template,
            onSuccess = _ref4.onSuccess;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var tempSamples, response;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            tempSamples = buildTempSamples(state, group, count || 1, template);

                            commit('ADD_TEMP_SAMPLES_TO_GROUP', { group: group, tempSamples: tempSamples });

                            commit('UPDATING_SAMPLES', true);
                            _context.prev = 3;
                            _context.next = 6;
                            return axios.post('/analysis/' + state.draft.analysis_order_id + '/groups/' + group.analysis_sample_group_id + '/samples', {
                                count: count,
                                template: template ? template : null
                            });

                        case 6:
                            response = _context.sent;


                            if (response.data) {
                                commit('REPLACE_TEMP_SAMPLES_WITH_REAL', {
                                    group: group,
                                    tempSamples: tempSamples,
                                    new_samples: response.data
                                });

                                if (typeof onSuccess === 'function') onSuccess();
                            } else {
                                commit('REMOVE_TEMP_SAMPLES_FROM_GROUP', { group: group, tempSamples: tempSamples });
                            }
                            _context.next = 14;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](3);

                            commit('REMOVE_TEMP_SAMPLES_FROM_GROUP', { group: group, tempSamples: tempSamples });
                            throw _context.t0;

                        case 14:
                            _context.prev = 14;

                            commit('UPDATING_SAMPLES', false);
                            return _context.finish(14);

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[3, 10, 14, 17]]);
        }))();
    },
    addMultipleSamplesToGroup: function addMultipleSamplesToGroup(_ref5, _ref6) {
        var _this2 = this;

        var state = _ref5.state,
            commit = _ref5.commit;
        var group = _ref6.group,
            samples = _ref6.samples,
            onSuccess = _ref6.onSuccess;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var response;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            commit('UPDATING_SAMPLES', true);

                            _context2.prev = 1;
                            _context2.next = 4;
                            return axios.post('/analysis/' + state.draft.analysis_order_id + '/groups/' + group.analysis_sample_group_id + '/samples', { samples: samples });

                        case 4:
                            response = _context2.sent;


                            if (response.data) {
                                commit('ADD_SAMPLES_TO_GROUP', { group: group, new_samples: response.data });

                                if (typeof onSuccess === 'function') {
                                    onSuccess();
                                }
                            }
                            _context2.next = 11;
                            break;

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](1);
                            throw _context2.t0;

                        case 11:
                            _context2.prev = 11;

                            commit('UPDATING_SAMPLES', false);
                            return _context2.finish(11);

                        case 14:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[1, 8, 11, 14]]);
        }))();
    },
    changeScreenLayout: function changeScreenLayout(_ref7, layout) {
        var commit = _ref7.commit;

        commit('CHANGE_SCREEN_LAYOUT', layout);
    },
    copyDown: function copyDown(_ref8) {
        var commit = _ref8.commit;
    },
    deleteItemKey: function deleteItemKey(_ref9, params) {
        var commit = _ref9.commit;

        commit('DELETE_ITEM_KEY', params);
    },
    dismissError: function dismissError(_ref10, index) {
        var state = _ref10.state,
            commit = _ref10.commit;

        if (_.has(state.errors, index)) {
            commit('DISMISS_ERROR', index);
        }
    },
    getSoilCropData: function getSoilCropData(_ref11) {
        var commit = _ref11.commit;

        commit('GET_SOIL_CROP_DATA');
    },
    initializeTestDetailsModal: function initializeTestDetailsModal(_ref12, el) {
        var commit = _ref12.commit;

        commit('INITIALIZE_TEST_DETAILS_MODAL', el);
    },
    loadSampleTypeFields: function loadSampleTypeFields(_ref13, sample_type_id) {
        var commit = _ref13.commit;

        commit('LOAD_SAMPLE_TYPE_FIELDS', sample_type_id);
    },
    loadSampleTypeTests: function loadSampleTypeTests(_ref14, sample_type_id) {
        var commit = _ref14.commit;

        commit('LOAD_SAMPLE_TYPE_TESTS', sample_type_id);
    },
    loadSampleTypeGroupDetailsSuggestions: function loadSampleTypeGroupDetailsSuggestions(_ref15, sample_type_id) {
        var commit = _ref15.commit;

        commit('LOAD_SAMPLE_TYPE_GROUP_DETAILS_SUGGESTIONS', sample_type_id);
    },
    removeItemFromArray: function removeItemFromArray(_ref16, params) {
        var commit = _ref16.commit;

        commit('REMOVE_ITEM_FROM_ARRAY', params);
    },
    removeSampleGroup: function removeSampleGroup(_ref17, group) {
        var commit = _ref17.commit;

        commit('REMOVE_SAMPLE_GROUP', group);
    },
    removeSampleFromGroup: function removeSampleFromGroup(_ref18, _ref19) {
        var commit = _ref18.commit;
        var group = _ref19.group,
            sample = _ref19.sample;

        commit('REMOVE_SAMPLE_FROM_GROUP', { group: group, sample: sample });
    },
    removeSamplesFromGroup: function removeSamplesFromGroup(_ref20, _ref21) {
        var _this3 = this;

        var state = _ref20.state,
            commit = _ref20.commit;
        var group = _ref21.group,
            analysis_sample_ids = _ref21.analysis_sample_ids;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!(!Array.isArray(analysis_sample_ids) || analysis_sample_ids.length === 0)) {
                                _context3.next = 2;
                                break;
                            }

                            return _context3.abrupt('return');

                        case 2:

                            commit('UPDATING_SAMPLES', true);
                            _context3.prev = 3;
                            _context3.next = 6;
                            return axios.delete('/analysis/' + state.draft.analysis_order_id + '/groups/' + group.analysis_sample_group_id + '/samples', { params: { analysis_sample_ids: analysis_sample_ids } });

                        case 6:

                            commit('REMOVE_SAMPLES_FROM_GROUP', { group: group, analysis_sample_ids: analysis_sample_ids });

                        case 7:
                            _context3.prev = 7;

                            commit('UPDATING_SAMPLES', false);
                            return _context3.finish(7);

                        case 10:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[3,, 7, 10]]);
        }))();
    },
    removeSoilRecRequest: function removeSoilRecRequest(_ref22, params) {
        var commit = _ref22.commit,
            dispatch = _ref22.dispatch;

        commit('REMOVE_SOIL_REC', params);
        dispatch('saveSampleRequest', params.sample);
    },
    saveDraftOrderRequest: function saveDraftOrderRequest(_ref23) {
        var state = _ref23.state;
        var draft = state.draft;
        var analysis_order_id = draft.analysis_order_id;


        return axios.put('/analysis/' + analysis_order_id, _extends({}, draft));
    },
    saveGroupSamplesRequest: function saveGroupSamplesRequest(_ref24, group) {
        var state = _ref24.state;
        var draft = state.draft;
        var analysis_order_id = draft.analysis_order_id;
        var analysis_sample_group_id = group.analysis_sample_group_id,
            samples = group.samples;


        return axios.put('/analysis/' + analysis_order_id + '/groups/' + analysis_sample_group_id + '/samples', {
            samples: samples
        });
    },
    saveGroupDetailsRequest: function saveGroupDetailsRequest(_ref25, group) {
        var state = _ref25.state;

        if (!group || !group.analysis_sample_group_id) return;

        axios.put('/analysis/' + state.draft.analysis_order_id + '/groups/' + group.analysis_sample_group_id, group);
    },
    saveOrderDetailsRequest: function saveOrderDetailsRequest(_ref26) {
        var commit = _ref26.commit;

        commit('SAVE_ORDER_DETAILS');
    },
    saveSampleRequest: function saveSampleRequest(_ref27, sample) {
        var state = _ref27.state;

        if (!sample || !sample.analysis_sample_id) return;
        if (typeof sample.analysis_sample_id === 'string' && sample.analysis_sample_id.startsWith('temp-')) return;

        axios.put('/analysis/' + state.draft.analysis_order_id + '/groups/' + sample.analysis_sample_group_id + '/samples/' + sample.analysis_sample_id, sample);
    },
    setAccount: function setAccount(_ref28, account) {
        var commit = _ref28.commit,
            dispatch = _ref28.dispatch;

        commit('SET_ACCOUNT', account);
        dispatch('retrieveDraftOrder');
        commit('LOAD_SAMPLE_TYPE_GROUPS');
    },
    updateLoading: function updateLoading(_ref29, loading) {
        var commit = _ref29.commit;

        commit('UPDATE_LOADING', loading);
    },
    updateUnavailableTests: function updateUnavailableTests(_ref30, _ref31) {
        var commit = _ref30.commit,
            dispatch = _ref30.dispatch;
        var group = _ref31.group,
            unavailable_tests = _ref31.unavailable_tests;

        commit('UPDATE_UNAVAILABLE_TESTS', { group: group, unavailable_tests: unavailable_tests });
        dispatch('saveGroupDetailsRequest', group);
    },
    retrieveDraftOrder: function retrieveDraftOrder(_ref32) {
        var _this4 = this;

        var commit = _ref32.commit,
            state = _ref32.state;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            var account, loading;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            account = state.account, loading = state.loading;

                            if (!(_.has(account, 'account_nbr') && !loading.draft_order)) {
                                _context4.next = 5;
                                break;
                            }

                            commit('UPDATE_DRAFT_ORDER', {});

                            _context4.next = 5;
                            return axios.get('/analysis/load-draft', {
                                params: {
                                    account_number: account.account_nbr
                                }
                            }).then(function (response) {
                                if (response.data) {
                                    commit('UPDATE_DRAFT_ORDER', response.data);
                                }
                            });

                        case 5:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    setItemValue: function setItemValue(_ref33) {
        var commit = _ref33.commit;
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        commit('SET_ITEM_VALUE', params);
    },
    setUser: function setUser(_ref34, user) {
        var commit = _ref34.commit,
            dispatch = _ref34.dispatch;

        commit('SET_USER', user);
        dispatch('retrieveDraftOrder');
    },
    showTestDetails: function showTestDetails(_ref35, _ref36) {
        var commit = _ref35.commit;
        var sample_type = _ref36.sample_type,
            test = _ref36.test;

        commit('SHOW_TEST_DETAILS', { sample_type: sample_type, test: test });
    },
    submitOrder: function submitOrder(_ref37) {
        var commit = _ref37.commit;

        commit('SUBMIT_DRAFT_ORDER');
    },
    updateAvailableCrops: function updateAvailableCrops(_ref38, available_crops) {
        var commit = _ref38.commit;

        commit('UPDATE_AVAILABLE_CROPS', available_crops);
    },
    updateImportFile: function updateImportFile(_ref39, import_file) {
        var commit = _ref39.commit;

        commit('UPDATE_IMPORT_FILE', import_file);
    },
    updateSoilRecs: function updateSoilRecs(_ref40) {
        var commit = _ref40.commit,
            dispatch = _ref40.dispatch;
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!params.sample || !params.recs) return;

        var soilrecs = params.recs.map(function (rec, i) {
            var soilrec = _.has(params.sample, ['soilrecs', i]) ? JSON.parse(JSON.stringify(params.sample.soilrecs[i])) : {};

            soilrec.crop_id = rec.crop_id;
            soilrec.yield = rec.yield;
            soilrec.previous_crop_id = rec.previous_crop_id;

            return soilrec;
        });

        if (JSON.stringify(soilrecs) !== JSON.stringify(params.sample.soilrecs)) {
            commit('SET_ITEM_VALUE', {
                item: params.sample,
                key: 'soilrecs',
                value: soilrecs
            });

            dispatch('saveSampleRequest', params.sample);
        }
    },
    updateUserBilling: function updateUserBilling(_ref41, can_see) {
        var commit = _ref41.commit;

        commit('UPDATE_USER_BILLING', can_see);
    },
    loadTestBlacklist: function loadTestBlacklist(_ref42) {
        var commit = _ref42.commit;

        commit('LOAD_TEST_BLACKLIST');
    }
};

exports.default = actions;

/***/ }),

/***/ "v0fX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var mutations = {
    setUserAccounts: function setUserAccounts(state, user_accounts) {
        state.user_accounts = user_accounts;
    },

    setVisibleUser: function setVisibleUser(state, user) {
        state.visible_user = user;
    },

    setAuthUser: function setAuthUser(state, user) {
        state.auth_user = user;
    },

    addRole: function addRole(state, data) {
        if (!state.user_accounts[data.account_index].rolesArray.hasOwnProperty(data.role_cd)) {
            switch (data.role_cd) {
                case 'ACT_ADM':
                    state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, { 'ACT_ADM': data.approved });
                    if (!state.user_accounts[data.account_index].rolesArray.hasOwnProperty('ANLYSIS')) {
                        state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, { 'ANLYSIS': data.approved });
                    }
                    if (!state.user_accounts[data.account_index].rolesArray.hasOwnProperty('RPRT')) {
                        state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, { 'RPRT': data.approved });
                    }
                    if (!state.user_accounts[data.account_index].rolesArray.hasOwnProperty('SUP')) {
                        state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, { 'SUP': data.approved });
                    }
                    if (!state.user_accounts[data.account_index].rolesArray.hasOwnProperty('BILL')) {
                        state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, { 'BILL': data.approved });
                    }
                    break;
                case 'ANLYSIS':
                    state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, { 'ANLYSIS': data.approved });
                    break;
                case 'RPRT':
                    state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, { 'RPRT': data.approved });
                    break;
                case 'SUP':
                    state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, { 'SUP': data.approved });
                    break;
                case 'BILL':
                    state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, { 'BILL': data.approved });
                    break;
            }
        }
    },

    deleteRole: function deleteRole(state, data) {
        Vue.delete(state.user_accounts[data.account_index].rolesArray, data.role_cd);
        //remove ACT_ADM if you are removing any other role
        Vue.delete(state.user_accounts[data.account_index].rolesArray, 'ACT_ADM');
    },

    unselectAccount: function unselectAccount(state, index) {
        state.user_accounts[index].rolesArray = {};
        state.user_accounts[index].has_pending_approval = false;
    },

    addAccountToList: function addAccountToList(state, user_account) {
        state.user_accounts.push(user_account);
    },

    approveRoles: function approveRoles(state, data, success) {
        Vue.set(state.user_accounts, data.account_index, data.user_account);

        //addNewApprovedRoles to the visible_user (if necessary)
        var approvedRoles = Object.keys(data.user_account.rolesArray);
        approvedRoles.forEach(function (item) {
            if (!state.visible_user.approved_roles.includes(item)) {
                state.visible_user.approved_roles.push(item);
            }
        });

        if (typeof success === 'function') success();
    }
};

exports.default = mutations;

/***/ })

/******/ });


// WEBPACK FOOTER //
// /js/app.vue.ac93f10e9438f8fa0e6a.js